import axios from "axios";

const BASE_PATH = "/Loan";

// ----------- Surety -------------------------

const GetSuretyList = async () => {
  return axios.get(`${BASE_PATH}/GetSuretyList`);
};

const GetSuretyByLoanNo = async (loanNo) => {
  return axios.get(`${BASE_PATH}/GetSuretyByLoanNo`, {
    params: { p_loanNo: loanNo },
  });
};

const AddSurety = async (payload) => {
  return axios.post(`${BASE_PATH}/AddSurety`, null, {
    params: {
      p_loanNo: payload.loanNo,
      p_employeeId: payload.employeeId,
      p_year: payload.year || new Date().getFullYear(),
      p_type: payload.type,
      p_remarks: payload.remarks || "",
      p_date: payload.date,
    },
  });
};

const UpdateSurety = async (payload) => {
  return axios.post(`${BASE_PATH}/UpdateSurety`, null, {
    params: {
      p_suretyId: payload.suretyId,
      p_employeeId: payload.employeeId,
      p_type: payload.type,
      p_remarks: payload.remarks || "",
      ...(payload.date ? { p_date: payload.date } : {}),
    },
  });
};

const DeleteSurety = async (suretyId) => {
  return axios.post(`${BASE_PATH}/DeleteSurety`, null, {
    params: { p_suretyId: suretyId },
  });
};

// ---------------- Loan Uploads -----------------

const ListLoanDocs = async (loanNo) => {
  return axios.get(`${BASE_PATH}/ListLoanDocs`, {
    params: { LoanNo: loanNo },
  });
};

const UploadLoanDocs = async (loanNo, docType, file) => {
  const formData = new FormData();
  formData.append(docType, file);

  return axios.post(`${BASE_PATH}/UploadLoanDocs`, formData, {
    params: { LoanNo: loanNo },
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const DeleteLoanDoc = async (loanNo, docType) => {
  return axios.post(`${BASE_PATH}/DeleteLoanDoc`, null, {
    params: { LoanNo: loanNo, DocType: docType },
  });
};

const DownloadLoanDoc = async (loanNo, docType) => {
  return axios.get(`${BASE_PATH}/DocumentPreview`, {
    params: {
      LoanNo: loanNo,
      DocType: docType,
    },
    responseType: "blob", 
  });
};

// --------- Loan Types -------------------
const GetAllLoanTypes = async () => {
    return axios.get(`${BASE_PATH}/GetAllLoanType`);
}

const GetLoanTypeById = async (loanTypeId) => {
    return axios.get(`${BASE_PATH}/GetLoanTypeById`, {
        params: {
            p_loanTypeId: loanTypeId,
        }
    })
}

const AddLoanType = async (payload) => {
    return axios.post(
        `${BASE_PATH}/AddLoanType`,
        null,
        {
            params: {
                p_categoryCode: payload.categoryCode, // 'M' for Loan, 'O' for Other Loans
                p_typeName: payload.typeName,
                p_description: payload.description || "",
            }
        }
    )
}

const UpdateLoanType = async (payload) => {
  return axios.post(`${BASE_PATH}/UpdateLoanType`, null, {
    params: {
      p_loanTypeId: payload.loanTypeId,
      p_categoryCode: payload.categoryCode,
      p_typeName: payload.typeName,
      p_description: payload.description || "",
      ...(payload.isActive !== undefined ? { p_isActive: payload.isActive ? 1 : 0 } : {}),
    },
  });
};

const loanDetailsService = {
  GetSuretyList,
  GetSuretyByLoanNo,
  AddSurety,
  UpdateSurety,
  DeleteSurety,
  ListLoanDocs,
  UploadLoanDocs,
  DeleteLoanDoc,
  DownloadLoanDoc,
  GetAllLoanTypes,
  GetLoanTypeById,
  AddLoanType,
  UpdateLoanType
};

export default loanDetailsService;